<template>
  <!-- <h2>楓之谷R儲值流程</h2> -->
  <div class="infoCenter enCss">
    <h3>Select Server</h3>
    <p>Please select the game server corresponding to your region.</p>
    <p>
      Please select the game server corresponding to your region. Please note
      that character data is not shared between different servers. For example,
      a character you create on the Americas server will not appear in the
      player list or rankings on the Europe server.
    </p>
    <img src="./../../../assets/info/en/1.png" />

    <h3>Game Sign in/Register</h3>
    <p>
      Currently, the game supports 4 login methods, including quick-sign-in,
      Facebook Login, Google account Login, and email Login. (If you are a US
      player with an existing mobile account, please bind an email address to
      your account before logging in to the WEB version. This will allow you to
      access the same account and characters on the WEB platform.)
    </p>
    <img src="./../../../assets/info/en/2.png" />
    <p>
      For quick-register, select [Register], manually enter a custom account and
      custom password, re-enter the password, and click the [Register] button
      below to complete account registration and enter the game.
    </p>
    <img src="./../../../assets/info/en/3.png" />
    <h3>Top-Up Center (Get up to 20% Rebate!)</h3>
    <p>
      1. Once you enter the game on PC and your character reaches Lv.17, the
      [Top-Up] function will be unlocked. Click on the [Shop] icon in the
      top-left corner or the [Blue Diamond] icon to access the pack purchase
      page.
    </p>
    <img src="./../../../assets/info/en/3_1.png" />
    <p>
      2. Click on any gift pack to open the top-up page and select your country
      and language.
    </p>
    <img src="./../../../assets/info/en/3_2.png" />
    <p>
      3. Select your preferred payment method and the item you wish to purchase.
    </p>
    <img src="./../../../assets/info/en/3_3.png" />
    <p>
      4. Enter the secondary confirmation screen to verify your server and
      character information. Once confirmed, please proceed with the payment.
    </p>
    <img src="./../../../assets/info/en/3_4.png" />
    <img src="./../../../assets/info/en/3_5.png" />
    <p>
      5. After a successful payment, please return to the game to claim your
      Colored Diamonds! (Colored Diamonds are a vital in-game currency that can
      be used to purchase any paid pack, top up Blue Diamonds, and increase your
      VIP prestige.)
    <img src="./../../../assets/info/en/3_6.png" />
    </p>
    <p>More Page Functions</p>
    <p>1. Download</p>
    <p>
      Click [Install] to open the game page in a separate window. It can then be
      pinned to the desktop taskbar for quick access. You can also find the
      launch icon in the [Start] menu.
    </p>
    <img src="./../../../assets/info/en/4.png" />

    <p>2. Official Website</p>
    <p>
      Click [Website] to jump to the official website page for the latest
      information!
    </p>
    <img src="./../../../assets/info/en/5.png" />
    <p>3. Collect</p>
    <p>
      Click [Collect], the page will be added to the favorites of the browser,
      you can directly open the game in the favorites of the browser.
    </p>

    <img src="./../../../assets/info/en/6.png" />

    <p>4. Customer Service</p>
    <p>
      Click the [Customer Service] button to enter the customer service center
      where you can view the quick FAQ questions to find solutions. If the quick
      questions still do not resolve your issue, please visit the official
      Facebook fan page and message the CM for assistance.
    </p>
    <p>
      Facebook：<a href="Facebook：https://www.facebook.com/Global.MapleStoryR"
        >Facebook：https://www.facebook.com/Global.MapleStoryR</a
      >
    </p>
    <img src="./../../../assets/info/en/7.png" />
  </div>
</template>

<script>
export default {
  name: "RastarEn",
  data() {
    return {};
  },
  created() {},
};
</script>

<style lang="scss" src="./style.scss" scoped></style>
